import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configUserProfiles_template} from "../components/templates/configUserProfiles_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class config_user_profiles extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: configUserProfiles_template;

    protected getModuleName(){

        return "config_user_profiles";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new configUserProfiles_template("list", this.viewModel, this);

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Author Profiles");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getAuthorDetails();
    }

    protected getAuthorDetails(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/author-profiles/";

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate);
        }
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){

        this.elementsList.setAuthorDetails(responseParsed.authorDetails);
        this.elementsList.setAuthorSettings(responseParsed.authorSettings);
    }

    protected save(){

        this.loadingIn(this.elementsList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/author-profiles/save";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.elementsList.getTemplateViewModel().authorDetails;

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;

        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");
                obj.getVnAppZone().showNotificationToModule();
            });
            obj.loadingOut(obj.elementsList.builtTemplate);
        }
    }

    public cancelChanges(){

        //refresh the page, no changes
        this.getAuthorDetails();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Changes cancelled!");
        this.getVnAppZone().showNotificationToModule();
    }

    protected saveAuthorSettings(){

        this.loadingIn(this.elementsList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/author-settings/save";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {
            'showJobTitleInAuthorPages' : this.elementsList.getTemplateViewModel().isJobTitleAuthorPagesEnabled() ? this.elementsList.getTemplateViewModel().isJobTitleAuthorPagesEnabled() : false,
            'showJobTitleInAuthorByline' : this.elementsList.getTemplateViewModel().isJobTitleAuthorBylineEnabled() ? this.elementsList.getTemplateViewModel().isJobTitleAuthorBylineEnabled() : false,
            'showJobTitleInAboutAuthor' : this.elementsList.getTemplateViewModel().isJobTitleAboutAuthorEnabled() ? this.elementsList.getTemplateViewModel().isJobTitleAboutAuthorEnabled() : false
        };

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;

        XHRHdl.execute();
    }
}


// WEBPACK FOOTER //
// ./js/modules/config_user_profiles.ts